import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const base64ToArrayBuffer = b64string => {
  // decode base64 string, remove space for IE compatibility
  const binaryString = window.atob(b64string.replace(/\s/g, ''));
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
};

const useGetPaystubImage = () => {
  const context = useAuthContext('paystubs:read');
  const client = useApolloClient();
  const getPaystubImage = useCallback(
    ({ country, checkSequence }) =>
      client
        .query({
          query: Queries.GetPaystubImage,
          variables: { country, checkSequence },
          context,
        })
        .then(response => {
          const paystubs = response.data.getCurrentUser.paystubs || [];
          const checkImage = (paystubs[0] || {}).checkImage;
          const arraybuffer = base64ToArrayBuffer(checkImage);
          const fileBlob = new Blob([arraybuffer], { type: 'application/pdf' });
          return URL.createObjectURL(fileBlob);
        }),
    [client, context],
  );
  return getPaystubImage;
};

export default useGetPaystubImage;
